const rows = [
  { feature: "Earn rate",              silver: "1.25x",        gold: "1.5x",           platinum: "2x",            bronze: "1x" },
  { feature: "Welcome bonus",          silver: "100 pts",      gold: "100 pts",        platinum: "100 pts",       bronze: "100 pts" },
  { feature: "Birthday bonus",         silver: "250 pts",      gold: "500 pts",        platinum: "1000 pts",      bronze: "100 pts" },
  { feature: "Tier qualification",     silver: "AED 1,500+",   gold: "AED 6,000+",     platinum: "AED 15,000+",   bronze: "AED 0" },
  { feature: "Free coffee",            silver: "Every 10th fill", gold: "Every 5th fill", platinum: "Every fill-up", bronze: "On join" },
  { feature: "Free car wash",          silver: "—",            gold: "1 / month",      platinum: "1 / week",      bronze: "—" },
  { feature: "Priority pump",          silver: "—",            gold: "Peak hours",     platinum: "24/7",          bronze: "—" },
  { feature: "VAT invoice on WhatsApp",silver: "✓",            gold: "✓",              platinum: "✓",             bronze: "✓" },
  { feature: "National Day bonus",     silver: "2x",           gold: "3x",             platinum: "5x",            bronze: "1.5x" },
  { feature: "Roadside assistance",    silver: "—",            gold: "1 call / year",  platinum: "Unlimited",     bronze: "—" },
];

export default function LoyaltyBenefits() {
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-benefits">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">THE BENEFITS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-4">Compare<br /><em className="font-light">your tier.</em></h1>
      <p className="text-neutral-600 max-w-2xl mb-10">Every Stellar Rewards benefit — free coffee, monthly car wash, priority pump access, VAT invoices on WhatsApp — laid out across the four tiers. All earning and redemption is in AED, at any Stellar forecourt across the UAE.</p>
      <div className="overflow-x-auto bg-white border border-black/10">
        <table className="data-table min-w-[800px]">
          <thead>
            <tr>
              <th className="!bg-black !text-white">FEATURE</th>
              <th className="!bg-black !text-white text-center">BRONZE</th>
              <th className="!bg-black !text-white text-center">SILVER</th>
              <th className="!bg-black !text-white text-center">GOLD</th>
              <th className="!bg-black !text-white text-center">PLATINUM</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.feature}>
                <td className="font-medium">{r.feature}</td>
                <td className="text-center">{r.bronze}</td>
                <td className="text-center">{r.silver}</td>
                <td className="text-center">{r.gold}</td>
                <td className="text-center font-semibold kazo-text-burgundy">{r.platinum}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
